export const TYPES = {
    SEARCH: 'SEARCH',
    DEALER: 'SELLER',
    DESIGNER: 'DESIGNER',
    USER_PREFERENCE: 'USER_PREFERENCE',
    CREATOR: 'CREATOR',
} as const;
